import {AppConfigurationService} from './app-configuration.service';
import {GlobalsService} from '../../globals.service';
import {AgaveService} from 'tq-agave';

export const agaveConfigurationFactory = async (appConfigurationService: AppConfigurationService, agaveService: AgaveService) => {
    try {
        const appConfig = await appConfigurationService.ensureInit();
        if (appConfig.agaveServiceUrl) {
            GlobalsService.agaveServiceUrl = appConfig.agaveServiceUrl;
        }
        if (appConfig.agaveProxy) {
            // Il tipo degli agave proxy e':
            // export interface AgaveConfig {
            //     agaveServiceUrl: string;
            //     agaveAdditionalParams?: { [p: string]: any }; <- ammettono gli additional params! aggiungili qui o già nel config.json
            //     applicationCode: string
            // }
            GlobalsService.agaveProxy = appConfig.agaveProxy;
            agaveService.readConfigs();
        }
        if (appConfig.microsoftLoginLink) {
            GlobalsService.microsoftLoginLink = appConfig.microsoftLoginLink;
        }
        if (appConfig.isCloud) {
            GlobalsService.isCloud = appConfig.isCloud;
        }
        if (appConfig.tqApps) {
            GlobalsService.tqApps = appConfig.tqApps;
        }
    } catch (_) {
        // in caso 404, non sovrascrivo
        console.warn('App Configuration not found. Using default values.');
    }
}
